import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import store from "./assets/unit/store";

import unit from "./assets/unit/unit";
import unit1 from "./assets/unit/util";
import "./assets/iconfont/iconfont.css";
import datalist from "./assets/unit/datalist.js";
import "@/assets/css/resrt.css";
import EleFormJsonEditor from "vue-ele-form-json-editor";
// 注册 json 组件
Vue.component("json-editor", EleFormJsonEditor);

Vue.config.productionTip = false;

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import "vxe-table-plugin-element/dist/style.css";
import VXETablePluginExportXLSX from "vxe-table-plugin-export-xlsx";
import VXETablePluginElement from "vxe-table-plugin-element";
VXETable.use(VXETablePluginElement);
VXETable.use(VXETablePluginExportXLSX);

import vAvoidRepeat from './assets/unit/preventReClick'
Vue.use(vAvoidRepeat)

Vue.prototype.$axios = axios;
Vue.prototype.$Datalist = datalist;
Vue.prototype.$Store = store;
Vue.prototype.$Unit = unit;
Vue.prototype.$Unit1 = unit1;
Vue.prototype.$XModal = VXETable;

Vue.use(VXETable);
Vue.use(ElementUI);

import base from "./assets/unit/log.js";
Vue.use(base);
import {
  message
} from "./assets/unit/message";
Vue.prototype.$message = message;

// 首先对拦截器的请求进行设置，并在方法中return config，此处为固定格式
axios.interceptors.request.use((config) => {
  // 表示在配置中的设置头消息的字段Authorization为从本地获取的token值
  config.headers.token = localStorage.getItem("agttoken");
  return config;
});
if (localStorage.getItem("agtmainapi")) {
  axios.defaults.baseURL = localStorage.getItem("agtmainapi");
} else {
  axios.defaults.baseURL = "http://erp16.cn/erp/";
}

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js